<div class="row">
  <div *ngIf="!controlIsDisabled('OtherIncomes')" class="col">
    <ngb-alert
      *ngIf="isConsumerLoanApplication; else creditDisclosure"
      class="mt-3 loan-disclosure"
      [dismissible]="false"
      type="light"
    >
      {{ loanDisclosureCopy }}
    </ngb-alert>
    <ng-template #creditDisclosure>
      <ngb-alert
        class="mt-3 credit-disclosure"
        [dismissible]="false"
        type="light"
      >
        {{ creditDisclosureCopy }}
      </ngb-alert>
    </ng-template>
  </div>
</div>
<div class="row">
  <div *ngIf="!controlIsDisabled('OtherIncomes')" class="col-12 col-md-12 col-lg-6">
    <div class="mb-3">
      <label class="form-label" for="selectOtherIncomes">
        Other Incomes (select all that apply)
        <span *ngIf="controlIsRequired('OtherIncomes')" class="color-error"
          >*</span
        >
      </label>
      <select
        multiple
        id="selectOtherIncomes"
        class="form-select"
        aria-label="Other incomes dropdown menu."
        [formControl]="getFormControl('OtherIncomes')"
        (change)="onChangeEvent($event)"
      >
        <option *ngFor="let item of otherIncomes" [value]="item.Value">
          {{ item.Text }}
        </option>
      </select>
      <button class="btn btn-link font-small" (click)="onClearEvent()">
        <small> Clear Other Incomes </small>
      </button>
    </div>
  </div>
  <div *ngIf="!controlIsDisabled('MonthlyAdditionalIncome')" class="col-12 col-md-6 col-lg-4">
    <div class="mb-3">
      <label class="form-label" for="monthlyAdditionalIncome">
        Monthly Additional Income
        <span
          *ngIf="controlIsRequired('MonthlyAdditionalIncome')"
          class="color-error"
          >*</span
        >
      </label>
      <div class="input-group mb-3">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          id="monthlyAdditionalIncome"
          placeholder="Amount"
          type="number"
          min="0"
          step="100"
          [formControl]="getFormControl('MonthlyAdditionalIncome')"
          aria-label="Monthly additional income (to the nearest dollar)"
        />
      </div>
    </div>
  </div>
</div>
